import React from 'react';
import { Calendar, Clock, Award, Star, CheckCircle, Shield, Users } from 'lucide-react';

const OverviewTab = ({ service, vendor, serviceRating, serviceReviews, formatPrice, startingPrice }) => {
  return (
    <div className="space-y-8">
      {/* Service Details */}
      <div className="pb-6 border-b border-gray-200">
        <h3 className="text-lg sm:text-xl font-light text-black mb-6">Service Details</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between py-3 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <Calendar className="w-5 h-5 text-black" />
              <span className="text-base font-light text-gray-700">Starting Price</span>
            </div>
            <span className="text-base font-light text-black">${formatPrice(startingPrice)}</span>
          </div>
          <div className="flex items-center justify-between py-3 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <Clock className="w-5 h-5 text-black" />
              <span className="text-base font-light text-gray-700">Duration</span>
            </div>
            <span className="text-base font-light text-black">
              {service?.min_duration_hours ? `${service.min_duration_hours}-${service.max_duration_hours || service.min_duration_hours} hours` : 'Flexible'}
            </span>
          </div>
          <div className="flex items-center justify-between py-3 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <Award className="w-5 h-5 text-black" />
              <span className="text-base font-light text-gray-700">Pricing Type</span>
            </div>
            <span className="text-base font-light text-black capitalize">{service?.price_type || 'Fixed'}</span>
          </div>
          <div className="flex items-center justify-between py-3">
            <div className="flex items-center gap-3">
              <Star className="w-5 h-5 text-black" />
              <span className="text-base font-light text-gray-700">Service Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-base font-light text-black">{serviceRating.toFixed(1)}</span>
              <div className="flex">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star 
                    key={star} 
                    className={`w-4 h-4 ${
                      star <= Math.floor(serviceRating) 
                        ? 'text-black fill-current' 
                        : 'text-gray-300'
                    }`} 
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Vendor Credentials */}
      <div className="pb-6 border-b border-gray-200">
        <h3 className="text-lg sm:text-xl font-light text-black mb-6">Vendor Credentials</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {vendor?.is_verified && (
            <div className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg">
              <CheckCircle className="w-5 h-5 text-black flex-shrink-0" />
              <div>
                <div className="text-sm font-light text-black">Verified Vendor</div>
                <div className="text-xs text-gray-600 font-light">Identity confirmed</div>
              </div>
            </div>
          )}
          {vendor?.has_insurance && (
            <div className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg">
              <Shield className="w-5 h-5 text-black flex-shrink-0" />
              <div>
                <div className="text-sm font-light text-black">Fully Insured</div>
                <div className="text-xs text-gray-600 font-light">Coverage included</div>
              </div>
            </div>
          )}
          <div className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg">
            <Users className="w-5 h-5 text-black flex-shrink-0" />
            <div>
              <div className="text-sm font-light text-black">{serviceReviews} Reviews</div>
              <div className="text-xs text-gray-600 font-light">Customer feedback</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;

